import { IAddressInputAddress } from '@opendoor/bricks';
import { bffSellerGlobalPagePath } from '../routes/pathBuilders';

import Raven from 'raven-js';
import * as api from './';
import * as analytics from './analytics';

export const getSellerFlowUUID = () => {
  const fragments = window.location.search.match(/sfuuid\=([-\w]+)/);
  if (!fragments) {
    return undefined;
  }
  return fragments[1];
};

export const getSellerFlowName = () => {
  const fragments = window.location.search.match(/sfname\=([-\w_]+)/);
  if (!fragments) {
    return undefined;
  }
  return fragments[1];
};

export const startAddressVerification = async (
  address: IAddressInputAddress,
  channel?: string,
  trackingKeywords?: string,
  partnerReferralId?: string,
) => {
  analytics.trackEvent('inputting', 'address', 'verifying', {
    ...address,
  });
  const options = {
    channel,
    partnerReferralId,
    seller_flow_name_override: getSellerFlowName(),
    seller_flow_uuid_override: getSellerFlowUUID(),
    trackingKeywords,
  };
  const error = await api
    .postAddress(address, options)
    .then(resp => {
      const lead = (resp as any).value.lead;
      analytics.register({
        'Offer ID': lead.token,
        'Offer Postal Code': lead.address.postal_code,
      });
      window.location.href = bffSellerGlobalPagePath({ token: lead.token, page: 'address' });
    })
    .catch(e => {
      analytics.trackEvent('lead', 'failed');
      Raven.captureException(e);
      return e;
    });
  return error;
};
